import React from 'react';

import {MonsterTrait as MonsterTraitComponent} from '../../../../pages/monsters/trait';
import {MonsterQuery, MonsterTrait} from '../../../../generated/types';
import {MarkdownPlugin} from './plugin';

type Props = {
	payload: {lairTraits: MonsterTrait[]; monster: MonsterQuery['monster']};
};

// {@currentLairsEffects}
export const CurrentLairsEffectsPlugin: MarkdownPlugin<Props> = ({payload}) => {
	return (
		<>
			{payload.lairTraits.map((feature) => (
				<MonsterTraitComponent
					id={feature.id}
					key={feature.id}
					title={`${feature.title}`}
					description={feature.description!}
					monster={payload.monster}
				/>
			))}
		</>
	);
};

// карточка, а не строчка текста: разбор ставит её отдельным блоком, а не внутрь абзаца
CurrentLairsEffectsPlugin.block = true;
